import React from 'react';
import SectionHeading from './SectionHeading';
import useScrollReveal from '../hooks/useScrollReveal';

const CHANNEL = 'https://www.youtube.com/@Aerveil-ai';

/** The film. Landscape, and the thing to lead with. */
const FILM_ID = 'mf-VBm4KvY0';

/** Vertical short, so it gets its own narrower column rather than being letterboxed. */
const SHORT_ID = 'c_xIrPfY1OQ';

const AerveilFilm = () => {
  const [ref, isVisible] = useScrollReveal({ threshold: 0.05 });

  return (
    <section id="film" className="section bg-night text-cream">
      <div className="shell">
        <SectionHeading
          dark
          number="05"
          label="Videos"
          title="Catch our videos for Aerveil on YouTube."
        />

        <div
          ref={ref}
          className={`mt-14 grid items-start gap-10 transition-all duration-700 ease-calm lg:grid-cols-12 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-5'
          }`}
        >
          {/* The film */}
          <figure className="m-0 lg:col-span-8">
            <div className="relative aspect-video w-full border border-cream/15">
              <iframe
                className="absolute inset-0 h-full w-full"
                src={`https://www.youtube.com/embed/${FILM_ID}`}
                title="Frost and spray decisions, block by block. Aerveil for vineyards."
                loading="lazy"
                allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div>
            <figcaption className="mt-3 font-mono text-[0.7rem] uppercase tracking-eyebrow text-cream/45">
              Frost and spray decisions, block by block
            </figcaption>
          </figure>

          {/* The short */}
          <div className="lg:col-span-4">
            <figure className="m-0 w-full max-w-[15rem]">
              <div
                className="relative w-full border border-cream/15"
                style={{ aspectRatio: '9 / 16' }}
              >
                <iframe
                  className="absolute inset-0 h-full w-full"
                  src={`https://www.youtube.com/embed/${SHORT_ID}`}
                  title="Why warmer winters make vineyard frost worse, not better."
                  loading="lazy"
                  allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
              </div>
              <figcaption className="mt-3 font-mono text-[0.7rem] uppercase tracking-eyebrow text-cream/45">
                Why warmer winters make frost worse
              </figcaption>
            </figure>

            <a
              href={CHANNEL}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-ghost-cream mt-8"
            >
              Aerveil on YouTube
              <svg
                className="h-3 w-3"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                aria-hidden="true"
              >
                <path d="M7 17L17 7M17 7H8M17 7v9" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AerveilFilm;
